import React, { FC } from 'react';

export const Loading: FC = () => <p>Loading...</p>;
